import React from "react";

/**
 * Full-screen light blur overlay while auth verification is in flight.
 * Blocks all interaction underneath.
 */
const AuthVerifyingOverlay = ({
  message = "Logging you in",
  darkMode = false,
  variant = "fullscreen",
}) => {
  const isInline = variant === "inline";

  return (
    <div
      className={
        isInline
          ? "flex w-full min-h-[120px] flex-col items-center justify-center gap-3 py-8"
          : "fixed inset-0 z-[100] flex cursor-wait flex-col items-center justify-center gap-3 bg-black/20 px-4 backdrop-blur-[2px]"
      }
      role="status"
      aria-live="polite"
      aria-busy="true"
      {...(isInline
        ? {}
        : {
            onClick: (e) => {
              e.preventDefault();
              e.stopPropagation();
            },
            onMouseDown: (e) => {
              e.preventDefault();
              e.stopPropagation();
            },
          })}
    >
      <div
        className="h-10 w-10 animate-spin rounded-full border-2 border-[var(--primary)] border-t-transparent"
        aria-hidden
      />
      <p
        className={`text-center text-sm font-medium ${
          darkMode ? "text-white" : "text-gray-900"
        }`}
      >
        {message}
      </p>
    </div>
  );
};

export default AuthVerifyingOverlay;
